import { c as _c } from "react/compiler-runtime";
import { Tag } from '@systemeio/components';
import { TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
interface AffiliateDashboardTagButtonProps {
  tag: {
    id: TagId;
    name: string;
  } | null | undefined;
  onClick: (tagId: TagId) => void;
}
export const AffiliateDashboardTagButton = t0 => {
  const $ = _c(3);
  const {
    tag,
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick || $[1] !== tag) {
    t1 = tag ? <Tag render={<button type="button" />} size="sm" className="max-w-full" title={tag.name} onClick={() => onClick(tag.id)}><span className="truncate">{tag.name}</span></Tag> : null;
    $[0] = onClick;
    $[1] = tag;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};